import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FoldoutItem from './FoldoutItem';
import { Spinner } from '..';
const Foldout = _ref => {
  let {
    nested,
    options,
    optionFlagKey,
    optionIconKey,
    optionSectionBodyKey,
    optionSectionKey,
    optionTitleKey,
    optionSubTitleKey,
    optionDescriptionKey,
    handleItem,
    loading
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading && /*#__PURE__*/React.createElement(Spinner, null), !loading && options.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: classNames('section', {
      nested
    })
  }, nested ? /*#__PURE__*/React.createElement(React.Fragment, null, item[optionSectionKey] && /*#__PURE__*/React.createElement("h5", {
    className: "section-title"
  }, item[optionSectionKey]), item[optionSectionBodyKey].map((nestedItem, nestedIndex) => /*#__PURE__*/React.createElement(FoldoutItem, {
    key: nestedIndex,
    item: nestedItem,
    optionFlagKey: optionFlagKey,
    optionIconKey: optionIconKey,
    optionTitleKey: optionTitleKey,
    optionSubTitleKey: optionSubTitleKey,
    optionDescriptionKey: optionDescriptionKey,
    handleItem: handleItem
  }))) : /*#__PURE__*/React.createElement(FoldoutItem, {
    item: item,
    optionFlagKey: optionFlagKey,
    optionIconKey: optionIconKey,
    optionTitleKey: optionTitleKey,
    optionSubTitleKey: optionSubTitleKey,
    optionDescriptionKey: optionDescriptionKey,
    handleItem: handleItem
  }))));
};
Foldout.propTypes = {
  nested: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.object),
  optionFlagKey: PropTypes.string,
  optionIconKey: PropTypes.string,
  optionSectionBodyKey: PropTypes.string,
  optionSectionKey: PropTypes.string,
  optionDescriptionKey: PropTypes.string,
  optionTitleKey: PropTypes.string,
  optionSubTitleKey: PropTypes.string,
  handleItem: PropTypes.func,
  loading: PropTypes.bool
};
export default /*#__PURE__*/memo(Foldout);